import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import CONSTANTS from '../utils/constants';
import { useTranslation } from "react-i18next";


export default function AdminMain() {
  const { t, i18n } = useTranslation();

    const [activeItem, setActiveItem] = useState();
    const [userPermissions, setUserPermissions] = useState([]);
    const [loadingPermissions, setLoadingPermissions] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();

    const dashboardItems = [
        { id: 1, icon: "bi-graph-up-arrow", text: t("analitika"), path: "/admin/home/analitica", page_id: 1 },
    { id: 2, icon: "bi-boxes", text: t("harytlar"), path: "/admin/home/products", page_id: 2 },
    { id: 3, icon: "bi-cart-check", text: t("sargytlar"), path: "/admin/home/orders", page_id: 6 },
    { id: 5, icon: "bi-grid", text: t("bolumler"), path: "/admin/home/category", page_id: 11 },
    { id: 6, icon: "bi-images", text: t("banner"), path: "/admin/home/banner", page_id: 15 },
    { id: 8, icon: "bi-geo-alt", text: t("sargyt_yerleri"), path: "/admin/home/order-price", page_id: 23 },
    { id: 9, icon: "bi-clock", text: t("sargyt_wagty"), path: "/admin/home/order-times", page_id: 27 },
    { id: 10, icon: "bi-chat-left", text: t("message"), path: "/admin/home/notifications", page_id: 31 },

    { id: 11, icon: "bi-person-gear", text: t("ulanyjylar"), path: "/admin/home/users", page_id: 31 },

    { id: 12, icon: "bi-gear ", text: t("sazlamalar"), path: "/admin/home/control", page_id: 35 },
    ];

    const filteredDashboardItems = dashboardItems.filter(item => userPermissions.includes(item.page_id));

    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                let userCookie = Cookies.get("user");
                console.log('User cookie (js-cookie):', userCookie);

                if (!userCookie) {
                    userCookie = localStorage.getItem('user');
                    console.log('Fallback user from localStorage:', userCookie);
                }

                if (!userCookie) { 
                    navigate('/admin'); 
                    return; 
                }

                const user = JSON.parse(userCookie);
                console.log('Parsed user:', user);
                if (!user?.id) { 
                    navigate('/admin'); 
                    return; 
                }

                const response = await axios.get(`${CONSTANTS.baseRoute}/permissions`, { params: { user_id: user.id } });
                setUserPermissions(response.data.permissions);
            } catch (error) {
                console.error('Error fetching permissions:', error);
                navigate('/admin');
            } finally {
                setLoadingPermissions(false);
            }
        };

        fetchPermissions();
    }, [navigate]);

    useEffect(() => {
        const currentItem = filteredDashboardItems.find(item => item.path === location.pathname);
        setActiveItem(currentItem ? currentItem.text : null);
    }, [location.pathname, filteredDashboardItems]);

    const handleItemClick = (item) => {
        setActiveItem(item.text);
        if (item.path) navigate(item.path);
    };

    if (loadingPermissions) return <div>Yükleniyor...</div>;

    return (
        <div className="admin-main flex-grow-1 p-4">
            <h2 className="mb-4 fw-bold text-dark">{t("welcome")}</h2>
            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-xl-4 g-2">
                {filteredDashboardItems.length > 0 ? filteredDashboardItems.map((item) => (
                    <div className="col" key={item.id}>
                        <div
                            className="card h-100 border-0 rounded-3 dashboard-card"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleItemClick(item)}
                        >
                            <div className="card-body d-flex align-items-center p-4">
                                <i className={`bi ${item.icon} fs-2 me-3 text-secondary`}></i>
                                <span className="fw-medium">{item.text}</span>
                            </div>
                        </div>
                    </div>
                )) : <div className="col-12 text-center text-muted">No permissions available</div>}
            </div>
        </div>
    );
}